import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=b4b08e9a&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=b4b08e9a&prod&scoped=true&lang=css"
import style1 from "./shopList.vue?vue&type=style&index=1&id=b4b08e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b08e9a",
  null
  
)

export default component.exports